import map from 'lodash/map';

import { Ancestry, sortMergedItems } from 'src/lib/hierarchy';
import { Topic, HierarchicalTopic } from 'src/actions/topics/topicsResource';
import { TopicAncestry } from 'src/actions/topics/topicsHierarchyResource';

export function sortMergedTopics({
  topics,
  topicsHierarchy,
}: {
  topics: { values: Topic[] };
  topicsHierarchy: { values: TopicAncestry[] };
}): HierarchicalTopic[] {
  const hierarchy = topicHierarchyToAncestries(topicsHierarchy.values);

  return sortMergedItems(hierarchy, topics.values);
}

export function topicHierarchyToAncestries(topicHierarchy: TopicAncestry[]): Ancestry[] {
  return map(topicHierarchy, ({ topicId, ancestralTopicId }) => {
    return {
      itemId: topicId,
      ancestorId: ancestralTopicId,
    };
  });
}
